/**
 * Placeholder doc ids under users/{uid}/studio/{projectId}/captures (and legacy root captures/).
 * Firestore rejects document id "__init__" (reserved) — do not use it.
 */
export const CAPTURES_SUBCOLLECTION_PLACEHOLDER_ID = '_capturesCollectionSeed';

/** Legacy id from before Firestore enforced reserved ids (filter only, do not write). */
const LEGACY_PLACEHOLDER_ID = '__init__';

export function isCapturesSubcollectionPlaceholder(doc) {
  const id = doc.id;
  const data = typeof doc.data === 'function' ? doc.data() : doc.data;
  if (id === LEGACY_PLACEHOLDER_ID || id === CAPTURES_SUBCOLLECTION_PLACEHOLDER_ID) return true;
  return !!(data && data._placeholder);
}

export function filterRealCaptureDocs(docs) {
  return docs.filter((d) => !isCapturesSubcollectionPlaceholder(d));
}
